import React from 'react';
import { useTranslation } from 'react-i18next';
import type { MembersLivingFilter, MembersPeopleFilters } from '@/types/members-list';

interface MembersPeopleFiltersProps {
  filters: MembersPeopleFilters;
  onChange: (filters: MembersPeopleFilters) => void;
}

const MembersPeopleFiltersBar: React.FC<MembersPeopleFiltersProps> = ({ filters, onChange }) => {
  const { t } = useTranslation('screens');

  const livingOptions: { value: MembersLivingFilter; label: string }[] = [
    { value: 'all', label: t('filters.all') },
    { value: 'living', label: t('filters.living') },
    { value: 'deceased', label: t('filters.deceased') }
  ];

  const setLiving = (living: MembersLivingFilter) => onChange({ ...filters, living });

  const toggleHasPhoto = () => onChange({ ...filters, hasPhoto: !filters.hasPhoto });

  const toggleHasNoRelationships = () => onChange({ ...filters, hasNoRelationships: !filters.hasNoRelationships });

  return (
    <div className="members-people-filters">
      <div className="members-people-filters__row members-people-filters__row--status">
        <span className="members-people-filters__label">{t('filters.status')}</span>
        <div className="members-people-filters__living" role="group" aria-label={t('filters.livingStatus')}>
          {livingOptions.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              className={`list-filter-toggle${filters.living === value ? ' list-filter-toggle--active' : ''}`}
              aria-pressed={filters.living === value}
              onClick={() => setLiving(value)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <span className="members-people-filters__divider" aria-hidden="true">
        |
      </span>
      <div className="members-people-filters__row members-people-filters__row--toggles">
        <span className="members-people-filters__label">{t('filters.showOnly')}</span>
        <div className="members-people-filters__toggles" role="group" aria-label={t('filters.additionalFilters')}>
          <button
            type="button"
            className={`list-filter-toggle${filters.hasPhoto ? ' list-filter-toggle--active' : ''}`}
            aria-pressed={filters.hasPhoto}
            onClick={toggleHasPhoto}
          >
            {t('filters.hasPhoto')}
          </button>
          <button
            type="button"
            className={`list-filter-toggle${filters.hasNoRelationships ? ' list-filter-toggle--active' : ''}`}
            aria-pressed={filters.hasNoRelationships}
            onClick={toggleHasNoRelationships}
          >
            {t('filters.noRelationships')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MembersPeopleFiltersBar;
